var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 8.75008C6.34733 8.75008 5.41634 9.68107 5.41634 10.8334V13.4311L18.1507 22.767C19.251 23.5743 20.7484 23.5743 21.8486 22.767L34.583 13.4311V10.8334C34.583 9.68107 33.652 8.75008 32.4997 8.75008H7.49967ZM5.41634 16.0157V27.5001C5.41634 28.6524 6.34733 29.5834 7.49967 29.5834H32.4997C33.652 29.5834 34.583 28.6524 34.583 27.5001V16.0157L23.0791 24.4467C21.2432 25.7878 18.7497 25.7878 16.9202 24.4467L5.41634 16.0157ZM3.33301 10.8334C3.33301 8.53524 5.2015 6.66675 7.49967 6.66675H32.4997C34.7979 6.66675 36.6663 8.53524 36.6663 10.8334V27.5001C36.6663 29.7983 34.7979 31.6667 32.4997 31.6667H7.49967C5.2015 31.6667 3.33301 29.7983 3.33301 27.5001V10.8334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.80c38053437f531fd437b25769ff09e3.svg";
export { ForwardRef as ReactComponent };